import React, { useState } from 'react';
import classNames from 'classnames';

import { forTemplate } from 'app/common/lib/util/i18n';

import { QueryContext } from './QueryContext';

import styles from './PageHeader.less';

const format = forTemplate('enterprise_list_header_component');

interface PageHeaderProps {
  title: string;
  description?: string;
  count?: number;
  totalCount?: number;
  isLoading?: boolean;
  isFiltering?: boolean;
  onShowAll?: () => void;
  sortComponent?: React.ReactNode;
  searchComponent?: React.ReactNode;
}

export const PageHeader = (props: PageHeaderProps) => {
  const {
    title,
    description,
    count,
    totalCount,
    isFiltering,
    isLoading,
    onShowAll,
    sortComponent,
    searchComponent,
  } = props;

  const [searchQuery, setSearchQuery] = useState('');

  const _onShowAll = () => {
    setSearchQuery('');
    onShowAll && onShowAll();
  };

  const subtitle = !isLoading && totalCount !== undefined && totalCount > 0 && (
    <div className={styles.subtitle}>
      {isFiltering
        ? format('showing-x-of-y', { count, total: totalCount })
        : format('total-count', { count: totalCount })}
    </div>
  );

  const sort = sortComponent && (
    <div className={styles.sort}>{sortComponent}</div>
  );

  const search = searchComponent && (
    <div className={styles.search}>
      <QueryContext.Provider
        value={{
          query: searchQuery,
          setQuery: setSearchQuery,
        }}
      >
        {searchComponent}
      </QueryContext.Provider>
    </div>
  );

  const showAll = isFiltering && (
    <a href="#" onClick={_onShowAll} role="button" className={styles.showAll}>
      {format('show-all')}
    </a>
  );

  return (
    <div className={styles.pageHeader}>
      <div className={classNames(styles.listHeader, 'u-clearfix')}>
        <div className={styles.title}>
          <h2>{title}</h2>
          {subtitle}
          {sort}
          {showAll}
        </div>
        {description && <div className={styles.description}>{description}</div>}
      </div>
      {search}
    </div>
  );
};
